import { c as _c } from "react/compiler-runtime";
import { FormControlLabel, Switch, type SwitchProps } from "@mui/material";
import React from "react";
type BooleanToggleInputProps = Omit<SwitchProps, "value" | "onChange"> & {
  value: string;
  onChange(value: string): void;
};
export const BooleanToggleInput: React.FC<BooleanToggleInputProps> = t0 => {
  const $ = _c(12);
  let restProps;
  let t1;
  let value;
  if ($[0] !== t0) {
    const {
      value: t2,
      onChange,
      ...t3
    } = t0;
    value = t2;
    restProps = t3;
    t1 = ev => {
      onChange(ev.target.checked ? "true" : "false");
    };
    $[0] = t0;
    $[1] = restProps;
    $[2] = t1;
    $[3] = value;
  } else {
    restProps = $[1];
    t1 = $[2];
    value = $[3];
  }
  const handleChange = t1;
  const t2 = value === "true";
  let t3;
  if ($[4] !== handleChange || $[5] !== restProps || $[6] !== t2) {
    t3 = <Switch checked={t2} onChange={handleChange} size="small" {...restProps} />;
    $[4] = handleChange;
    $[5] = restProps;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = value === "true" ? "True" : "False";
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      ml: 1
    };
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t4) {
    t6 = <FormControlLabel control={t3} label={t4} labelPlacement="end" sx={t5} />;
    $[9] = t3;
    $[10] = t4;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};